import type { VAxios } from '../../define/axios/Axios';

export const createApi = (defHttp: VAxios) => ({
  // 词库列表
  getWordbookList: (params) => {
    return defHttp.get({ url: '/goods-title/lib', params });
  },
  // 创建词库
  createWordbook: (params) => {
    return defHttp.post({ url: '/goods-title/lib', params });
  },
  // 创建词库
  copyWordbook: (id) => {
    return defHttp.post({ url: `/goods-title/lib/${id}/copy` });
  },
  // 修改词库
  updateWordbook: (id, params) => {
    return defHttp.put({ url: `/goods-title/lib/${id}`, params });
  },
  // 删除词库
  deleteWordbook: (id) => {
    return defHttp.delete({ url: `/goods-title/lib/${id}` });
  },

  getWordbookById: (id) => {
    return defHttp.get({ url: `/goods-title/lib/${id}` });
  },
  // 词库词项详情（分页）
  getWordbookDetail: (id, params) => {
    return defHttp.get({ url: `/goods-title/lib/${id}/items`, params });
  },
  // 给词库添加词项
  addWordbookItem: (id, params) => {
    return defHttp.put({ url: `/goods-title/lib/${id}/items`, params });
  },

  // 修改单个词项
  updateWordbookItem: (itemId, params) => {
    return defHttp.put({ url: `/goods-title/lib/items/${itemId}`, params });
  },
  // 删除单个词项
  deleteWordbookItem: (itemId) => {
    return defHttp.delete({ url: `/goods-title/lib/items/${itemId}` });
  },
  // 解析词项文件
  parseWordbookFile: (url) => {
    return defHttp.post({ url: '/goods-title/lib/files', params: { url } });
  },
});
